import { createAction, props } from '@ngrx/store';

export const setTechChartSecuritylistSecurityId = createAction(
    '[Tech Chart] Set Security List Security Id',
    props<{ securitylistSecurityId: string }>()
);
